module.exports = __webpack_public_path__ + "img/caas1m.e2533eec.webp";